/**
 * The invite a signed-out visitor was looking at. Sign-up ends at the
 * confirmation email, whose link comes from the auth service and cannot carry
 * `?next`, so `/confirm-email` reads this to send the new user back to the
 * invite. localStorage, because the confirmation link usually opens a new tab.
 */

const KEY = 'friday.pendingInvite'
const TTL_MS = 24 * 60 * 60 * 1000

export function rememberPendingInvite(token: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ path: `/invite/${token}`, at: Date.now() }))
  } catch {
    // Storage blocked: the visitor can still reopen the invite link.
  }
}

export function pendingInvitePath(): string | undefined {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return undefined
    const { path, at } = JSON.parse(raw) as { path?: unknown; at?: unknown }
    if (typeof path !== 'string' || !path.startsWith('/invite/') || typeof at !== 'number') return undefined
    return Date.now() - at < TTL_MS ? path : undefined
  } catch {
    return undefined
  }
}

export function clearPendingInvite(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // Nothing to clear.
  }
}
